import React, { createContext, useContext, useCallback } from "react";

const JOTFORM_URL = "https://form.jotform.com/252442123733045";

const QuoteContext = createContext({ openQuote: () => {} });

export const useQuote = () => useContext(QuoteContext);

export const QuoteProvider = ({ children }) => {
  const openQuote = useCallback(() => {
    // Open JotForm in a new tab — avoids embedded iframe form-view counts
    window.open(JOTFORM_URL, "_blank", "noopener,noreferrer");
  }, []);

  return (
    <QuoteContext.Provider value={{ openQuote }}>
      {children}
    </QuoteContext.Provider>
  );
};
